import { render, staticRenderFns } from "./CurrentQueue.vue?vue&type=template&id=431a81c6&scoped=true&"
import script from "./CurrentQueue.vue?vue&type=script&lang=js&"
export * from "./CurrentQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431a81c6",
  null
  
)

export default component.exports